import {
  BottomSheet,
  BottomSheetIllustrationContent,
  type UseModalState,
} from "@clipboard-health/ui-components";
import { getTheme } from "@clipboard-health/ui-theme";
import { ThemeProvider } from "@mui/material";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { LoadingButton } from "@src/appV2/redesign/components/LoadingButton";

interface Props {
  modalState: UseModalState;
  onConfirm: () => Promise<void>;
  isLoading: boolean;
}

export function ReactivationRequiredDialog(props: Props) {
  const { modalState, onConfirm, isLoading } = props;
  const theme = getTheme();

  return (
    <ThemeProvider theme={theme}>
      <BottomSheet canDismiss modalState={modalState}>
        <BottomSheetIllustrationContent
          illustrationType="warning"
          title="Account Verification Required"
          description="Your account requires verification to continue. Please verify your phone number and email address to continue."
        />
        <DialogFooter orientation="horizontal">
          <LoadingButton
            fullWidth
            variant="contained"
            size="large"
            isLoading={isLoading}
            aria-label="OK"
            onClick={async () => {
              await onConfirm();
              modalState.closeModal();
            }}
          >
            Start Verification
          </LoadingButton>
        </DialogFooter>
      </BottomSheet>
    </ThemeProvider>
  );
}
